// @ts-nocheck
import React, { createRef } from "react";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import TaskInformation from "../../../sections/taskInfoSections";
import PageHeader from "../../../commonComponents/pageHeaders/PageHeader";
import ReadOnlyProcedureFileSection from "../../../sections/procedureFileSections/readOnlyProcedureFileSection";
import ReadOnlySupportingFileSection from "../../../sections/supportingFileSections/readOnlySupportingFileSection";
import ActiveShareTaskReadOnly from "../../../sections/sharedTaskSections/activeShareTaskReadOnly";
import ProcedureDetailService from "../../../../service/procedureFile/ProcedureDetailService";
import styles from "../index.module.scss";
import ChangePOService from "../../../../service/changePO";
import ChangePOProcedureInformation from "../../../sections/procedureInfoSections/changePOProcedureInfoSection";
import ProcessBase from "../../../commonComponents/processBase";
import NormalSpin from "../../../../base/basicComponents/spin";
import StepService from "../../../../service/stepBase/StepService";
import StepBusinessType from "../../../../service/stepBase/stepBusinessType";
import CompleteStepBusinessType from "../../../../service/stepBase/completeStepBusinessType";
import ChangePOStepService from "../../../../service/changePO/changePOStepService";
import { disableInteraction, enableInteraction } from "utils";

const procedureFileRef = createRef();
const supportingFileRef = createRef();
const procedureInfoRef = createRef();
export default class ChangePOCompleted extends ProcessBase {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
      pageHeadState: this.initChangePOCompletedPageHeadState(),
      procedureFileData: this.initChangePOCompletedProcedureFileData(),
      supportingFileData: [],
      procedureInfoState: {},
      taskInformationData: [],
      shareTask: this.initChangePOCompletedShareTask(),
      jbProcedureSavedIn: null,
    };
    // @ts-ignore
    this.params = {
      TaskId: this._getRoutingParam("ProcedureTaskId"),
      ProcedureID: this._getRoutingParam("ProcedureID"),
      ProcedureStepID: this._getRoutingParam("ProcedureStepID"),
    };
  }

  initChangePOCompletedPageHeadState = () => {
    return {
      receiveDate: null,
      requestByName: null,
      procedureStepStatus: null,
    };
  };

  initChangePOCompletedProcedureFileData = () => {
    return {
      procedureTableData: [],
      clientServerPath: null,
      savedInRadioValue: null,
    };
  };

  initChangePOCompletedShareTask = () => {
    return {
      mainTaskAccountId: null,
      procedureProcessID: null,
      reason: null,
      returnReasonLogs: null,
      shareTaskAccountId: null,
      shareTaskProcedureStepID: null,
      shareTasks: [],
      submitReasonLogs: null,
    };
  };

  _showChangePOCompletedLoading = () => {
    disableInteraction();
    this.setState({ loading: true });
  };

  _hideChangePOCompletedLoading = async () => {
    await enableInteraction();
    this.setState({ loading: false });
  };

  closeChangePOCompletedPage = () => {
    // @ts-ignore
    window.location = "/ToDoList";
  };

  setProcedureFileData = (result: any) => {
    if (result.procedureFolder !== null) {
      this.setProcedureTableData(result.procedureFolder);
      this.setState({
        procedureFileData: {
          savedInRadioValue:
            result.procedureFolder !== null
              ? result.procedureFolder.procedureSaveInCategoryID
              : null,
          clientServerPath:
            result.procedureFolder !== null ? result.procedureFolder.clientServerPath : "",
          // @ts-ignore
          procedureTableData: this.procedureTableData,
        },
        // @ts-ignore
        supportingFileData: this.supportingTableData,
        jbProcedureSavedIn:
          result.procedureFolder === null ? null : result.procedureFolder.jbProcedureSaveIn,
      });
    }
  };

  setSupportingFileData = (result: any) => {
    if (result.supportingFolder !== null) {
      this.setSupportingTableData(result);
      this.setState({
        // @ts-ignore
        supportingFileData: this.supportingTableData,
      });
    }
  };

  setShareTaskData = (result: any) => {
    if (result.shareTask === null || result.shareTask === undefined) {
      return;
    }

    this.setState({
      shareTask: result.shareTask,
    });
  };

  _getProcedureOwnerStepItemSuccess = (response: any, flowDataResult: any) => {
    const result = { ...response, ...flowDataResult };
    const {
      statusCode,
      message,
      reviceDate,
      requestByName,
      primaryProcedureOwner,
      procedureOwner,
      procedureNote,
      shareTask,
      applyPmpExcluded,
      procedureFolder,
      procedureStepStatus,
      workflowProcessInstanceId,
      workflowProcessStepInfo,
      procedureStatusID,
      taskInfomation,
    } = result;
    if (statusCode === 401) {
      this._alertError(message);
    } else {
      this.setProcedureTableData(procedureFolder);
      this.setSupportingTableData(result);
      this.setState({
        pageHeadState: {
          receiveDate: this._formateDate(reviceDate),
          requestByName,
          procedureStepStatus,
        },
        procedureInfoState: {
          ...this.state.procedureInfoState,
          primaryProcedureOwner,
          procedureOwner: procedureOwner,
          workflowProcessInstanceId,
          isExcluded: applyPmpExcluded?.isExcluded ? "Yes" : "No",
          procedureNote,
          workflowProcessStepInfo,
          procedureStatus: procedureStatusID,
        },
        shareTask,
        procedureFileData: {
          savedInRadioValue:
            result.procedureFolder === null
              ? null
              : result.procedureFolder.procedureSaveInCategoryID,
          clientServerPath:
            result.procedureFolder !== null ? result.procedureFolder.clientServerPath : "",
          // @ts-ignore
          procedureTableData: this.procedureTableData,
        },
        // @ts-ignore
        supportingFileData: this.supportingTableData,
        jbProcedureSavedIn:
          result.procedureFolder === null ? null : result.procedureFolder.jbProcedureSaveIn,
        taskInformationData: taskInfomation,
      });
      this._hideChangePOCompletedLoading();
    }
  };

  _getProcedureOwnerStepItemFailed = () => {
    this._alertError("Get Procedure Owner Step Item Failed");
  };

  _getFlowDataSuccess = (result: any, param: any) => {
    const { procedureStepStatus } = result;
    let mergePayloadMap = undefined;

    StepService.setStepInterfaceMergePayload(result, {
      isShareTaskProcess: false,
      isHistorical: procedureStepStatus === "Complete",
      // @ts-ignore
      procedureStepId: this.procedureStepID,
      // @ts-ignore
      procedureTaskId: this.taskID,
    });

    if (procedureStepStatus === "Complete") {
      ChangePOStepService.getPrimaryProcedureOwnerStepKey = () =>
        CompleteStepBusinessType.primaryProcedureOwner;
      ChangePOStepService.getPMPExcludedStepKey = () => CompleteStepBusinessType.pmpExcluded;

      mergePayloadMap = StepService.getMergePayloadBySettingKey([
        CompleteStepBusinessType.pmpExcluded.settingKey,
        CompleteStepBusinessType.primaryProcedureOwner.settingKey,
      ]);
    }

    ChangePOService.getProcedureOwnerStepItem(
      param,
      (response: any) => this._getProcedureOwnerStepItemSuccess(response, result),
      this._getProcedureOwnerStepItemFailed,
      undefined,
      {
        ...mergePayloadMap,
        ...StepService.getMergePayloadBySettingKey([CompleteStepBusinessType.taskInfo.settingKey]),
      }
    );
  };

  _getFlowDataFailed = () => {
    this._alertError("Get Procedure Owner Flow Data Failed");
  };

  getFlowData = () => {
    const parentPageData = this._getRoutingParam("ParentPage");
    const param = {
      // @ts-ignore
      taskID: this.taskID,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: parentPageData,
    };

    ChangePOService.getFlowStepData(
      param,
      (response: any) => this._getFlowDataSuccess(response, param),
      this._getFlowDataFailed
    );
  };

  _getPrimaryProcedureOwnerDDLSuccess = (result: any) => {
    this.setState({
      procedureInfoState: {
        ...this.state.procedureInfoState,
        ppoList: result,
      },
    });
  };

  _getPrimaryProcedureOwnerDDLFailed = () => {
    this._alertError("Get Primary Procedure Owner List Failed");
  };

  getPrimaryProcedureOwnerDDL = () => {
    // @ts-ignore
    ProcedureDetailService.getPrimaryProcedureOwnerDDL(
      this.taskID,
      this._getPrimaryProcedureOwnerDDLSuccess,
      this._getPrimaryProcedureOwnerDDLFailed
    );
  };

  componentDidMount() {
    this._showChangePOCompletedLoading();
    this.getFlowData();
  }

  handleChangePOCompletedPageHeader = () => {
    const { receiveDate, requestByName, procedureStepStatus } = this.state.pageHeadState;
    const isReassignPending = procedureStepStatus === "Pending";

    return (
      <div className={styles.header}>
        <PageHeader
          title="Change Procedure Owner"
          receiveDate={this._formateDate(receiveDate)}
          requestBy={requestByName}
          status={procedureStepStatus ? (isReassignPending ? "Pending" : "Complete") : ""}
        />
      </div>
    );
  };

  handleChangePOCompletedTaskInformation = (isCompletePage: any) => {
    const { taskInformationData } = this.state;

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={<TaskInformation data={taskInformationData} />}
        isShowArrow={true}
        isOpen={false}
        testid="task-info-block-arrow"
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            {
              // @ts-ignore
              procedureStepId: this.params.ProcedureStepID,
              // @ts-ignore
              procedureTaskId: this.params.TaskId,
              isHistorical: isCompletePage,
            },
            this.setTaskInfoData,
            this.setError,
            [StepBusinessType.taskInfo]
          );
        }}
      />
    );
  };

  handleChangePOCompletedProcedureFileSection = (isCompletePage: any) => {
    const { jbProcedureSavedIn } = this.state;

    const { procedureTableData, clientServerPath, savedInRadioValue } =
      this.state.procedureFileData;

    return (
      <ProcedureBlock
        child={
          <ReadOnlyProcedureFileSection
            procedureFileData={procedureTableData}
            procedureFileRef={procedureFileRef}
            clientServerPath={clientServerPath}
            savedInRadioValue={savedInRadioValue}
            jbProcedureSavedIn={jbProcedureSavedIn}
          />
        }
        isShowArrow={true}
        isOpen={false}
        testid="procedure-file-block-arrow"
        onShowDataLoad={() => {
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.setProcedureFileData,
            this.setError,
            [
              isCompletePage
                ? CompleteStepBusinessType.procedureFile
                : StepBusinessType.procedureFile,
            ],
            isCompletePage &&
              StepService.getMergePayloadBySettingKey([
                CompleteStepBusinessType.procedureFile.settingKey,
              ])
          );
        }}
      />
    );
  };

  handleChangePOCompletedSupportingFileSection = (isCompletePage: any) => {
    return (
      <ProcedureBlock
        child={
          <ReadOnlySupportingFileSection
            supportingFileRef={supportingFileRef}
            supportingFileData={this.state.supportingFileData}
          />
        }
        isShowArrow={true}
        isOpen={false}
        testid="supporting-file-block-arrow"
        onShowDataLoad={() => {
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.setSupportingFileData,
            this.setError,
            [
              isCompletePage
                ? CompleteStepBusinessType.supportingFile
                : StepBusinessType.supportingFile,
            ],
            isCompletePage &&
              StepService.getMergePayloadBySettingKey([
                CompleteStepBusinessType.supportingFile.settingKey,
              ])
          );
        }}
      />
    );
  };

  handleChangePOCompletedProcedureInformation = () => {
    const { procedureStepStatus } = this.state.pageHeadState;
    const { procedureInfoState } = this.state;
    const procedureData = {
      ...procedureInfoState,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
    };
    const params = {
      // @ts-ignore
      ProcedureTaskId: this.taskID,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
    };
    const isReassignPending = procedureStepStatus === "Pending";

    return (
      <ProcedureBlock
        className={styles.ProcedureInfoSection}
        child={
          // @ts-ignore
          <ChangePOProcedureInformation
            ref={procedureInfoRef}
            procedureTaskId={(this as any).taskID}
            procedureData={procedureData}
            submitData={procedureInfoState}
            noteDisabled={true}
            isPPODisabled={true}
            title="Procedure Information"
            closePage={this.closeChangePOCompletedPage}
            isReassignPending={isReassignPending}
            _showLoading={this._showChangePOCompletedLoading}
            _hideLoading={this._hideChangePOCompletedLoading}
            params={params}
          />
        }
        isShowArrow={true}
        isOpen={true}
        testid="change-po-block-arrow"
      />
    );
  };

  handleChangePOCompletedShareTaskSection = (isCompletePage: any) => {
    const { shareTask } = this.state;

    return (
      <ProcedureBlock
        className={styles.approveProcedureBlock}
        child={<ActiveShareTaskReadOnly shareTaskData={shareTask} />}
        isShowArrow={true}
        isOpen={false}
        testid="share-task-block-arrow"
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            {
              // @ts-ignore
              ...this.params,
              isHistorical: isCompletePage,
              isShareTaskProcess: false,
            },
            this.setShareTaskData,
            this.setError,
            [StepBusinessType.shareTask]
          );
        }}
      />
    );
  };

  render() {
    const { loading, pageHeadState } = this.state;

    const isCompletePage = pageHeadState.procedureStepStatus === "Complete";

    return (
      // @ts-ignore
      <NormalSpin spinning={loading} size="large" zIndex={1500}>
        <div className={styles.body}>
          {this.handleChangePOCompletedPageHeader()}
          {this.handleChangePOCompletedTaskInformation(isCompletePage)}
          {this.handleChangePOCompletedProcedureFileSection(isCompletePage)}
          {this.handleChangePOCompletedSupportingFileSection(isCompletePage)}
          {this.handleChangePOCompletedProcedureInformation()}
          {this.handleChangePOCompletedShareTaskSection(isCompletePage)}
        </div>
      </NormalSpin>
    );
  }
}
